export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "parseGridNftDataToCanvas.worker.9dbe869c6a19a88be6c3.worker.js");
}
